import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useParams, useLocation} from 'react-router-dom';
import _isEmpty from 'lodash/isEmpty';
import Strapi from '../../../../components/strapi';
import LoadingPage from '../../../../components/loadingpage';
import useWindowWidth from '../../../../components/hooks/useWindowWidth';
import GetStrapiContent from '../../../../components/strapi/getstrapicontent';

export default function AccessibilityStatement() {
  const location = useLocation();
  const [isLoaded, setIsLoaded] = useState(false);
  const {i18n} = useTranslation();
  const width = useWindowWidth();
  const {productType} = useParams();
  const {strapiContent} = GetStrapiContent(
    'COMPANY_ACCESSIBILITY',
    setIsLoaded,
    location,
    true,
    productType
  );
  if (!isLoaded || _isEmpty(strapiContent)) return <LoadingPage />;

  return (
    <div>
      {strapiContent.map((s, i) => (
        <div key={`accessibility-statement-page-strapi-sec${i}`}>
          <Strapi
            content={s}
            width={width}
            productPage={'accessibility-statement'}
            i18n={i18n}
          />
        </div>
      ))}
    </div>
  );
}
